import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { ListChecks, Loader2, ArrowRight } from 'lucide-react';
import { AdminPageHeader, API } from './_P1Common';
import { useAdmin } from '@/hooks/useAdmin';

const STATUSES = [
  { key: 'draft', label: 'Nacrti', accent: 'bg-zinc-800' },
  { key: 'review', label: 'Recenzija', accent: 'bg-amber-900/40' },
  { key: 'scheduled', label: 'Zakazano', accent: 'bg-sky-900/40' },
  { key: 'published', label: 'Objavljeno', accent: 'bg-emerald-900/40' },
];

export default function AdminWorkflow() {
  const { authFetch } = useAdmin();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await authFetch(`${API}/admin/workflow`);
      setData(await r.json());
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const move = async (id, status) => {
    const r = await authFetch(`${API}/admin/workflow/${id}/move`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status }),
    });
    if (r.ok) { toast.success('Pomaknuto'); load(); }
  };

  if (loading || !data) return <AdminPageHeader icon={ListChecks} title="Uređivački tijek rada"><Loader2 className="animate-spin"/></AdminPageHeader>;

  return (
    <div data-testid="admin-workflow">
      <AdminPageHeader icon={ListChecks} title="Uređivački tijek rada" subtitle="Kanban prikaz po statusu članaka"/>
      <div className="px-4 md:px-6 pb-6 grid grid-cols-1 md:grid-cols-4 gap-3">
        {STATUSES.map((s, idx) => (
          <div key={s.key} data-testid={`wf-col-${s.key}`} className={`rounded-lg border border-zinc-800 ${s.accent}`}>
            <div className="p-3 border-b border-zinc-800 flex items-center justify-between">
              <h3 className="font-bold text-sm">{s.label}</h3>
              <span className="text-xs text-zinc-400">{(data.counts?.[s.key] || 0)}</span>
            </div>
            <div className="p-2 space-y-2 max-h-[70vh] overflow-auto">
              {(data.buckets?.[s.key] || []).map(a => (
                <div key={a.id} className="bg-zinc-950 border border-zinc-800 rounded p-2">
                  <div className="text-sm font-medium line-clamp-2">{a.title}</div>
                  <div className="text-xs text-zinc-500 mt-1 line-clamp-1">{a.author || '—'}</div>
                  {idx < STATUSES.length - 1 && (
                    <button onClick={() => move(a.id, STATUSES[idx + 1].key)}
                            data-testid={`wf-move-${a.id}`}
                            className="mt-2 inline-flex items-center gap-1 text-xs text-red-400 hover:text-red-300">
                      <ArrowRight size={12}/> Premjesti u "{STATUSES[idx + 1].label}"
                    </button>
                  )}
                </div>
              ))}
              {(data.buckets?.[s.key] || []).length === 0 && (
                <div className="text-xs text-zinc-500 italic p-2">Prazno.</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
